import { Heart, Phone, Users, RotateCcw } from "lucide-react";
import { Shell } from "@/components/Shell";

export function SelfHarmHalt({ onRestart }) {
  return (
    <Shell showProgress={false}>
      <div
        className="mt-6 rounded-3xl bg-[hsl(var(--arena))] p-6 border-2 border-[hsl(var(--olivo))]"
        data-testid="selfharm-halt"
      >
        <div className="flex items-center gap-3">
          <Heart className="h-7 w-7 text-[hsl(var(--coral))]" aria-hidden="true" />
          <span className="cc-eyebrow">Ayuda inmediata</span>
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl mt-4 leading-tight">
          No estás sola. Hay ayuda disponible ahora
        </h1>
        <p className="mt-4 text-[hsl(var(--texto))] leading-relaxed">
          Lo que estás sintiendo es importante. Por favor, busca apoyo cuanto antes
          con un servicio de salud o con alguien de confianza.
        </p>

        <div className="mt-6 space-y-3">
          <div className="cc-card p-4 flex items-start gap-3">
            <Phone className="h-5 w-5 text-[hsl(var(--olivo))] mt-0.5 shrink-0" aria-hidden="true" />
            <div>
              <p className="font-medium">Contacta con un servicio de emergencias</p>
              <p className="text-sm text-[hsl(var(--muted-foreground))]">
                Llama al número local de emergencias de tu país o acude a un servicio
                de salud mental.
              </p>
            </div>
          </div>
          <div className="cc-card p-4 flex items-start gap-3">
            <Users className="h-5 w-5 text-[hsl(var(--olivo))] mt-0.5 shrink-0" aria-hidden="true" />
            <div>
              <p className="font-medium">Habla con una persona de confianza</p>
              <p className="text-sm text-[hsl(var(--muted-foreground))]">
                Un familiar, amistad o profesional puede acompañarte en este momento.
              </p>
            </div>
          </div>
        </div>

        <p className="mt-6 text-sm text-[hsl(var(--muted-foreground))]">
          Este mensaje es orientativo y no sustituye la evaluación profesional. No
          registramos ni compartimos tus respuestas.
        </p>
      </div>

      <div className="mt-6">
        <button
          onClick={onRestart}
          className="cc-btn-outline w-full"
          data-testid="selfharm-restart-btn"
        >
          <RotateCcw className="h-4 w-4" />
          Comenzar de nuevo
        </button>
      </div>
    </Shell>
  );
}
